<template>
  <section v-if="history.length > 0" class="bg-white p-3 border border-gray-200 rounded-md">
    <div class="flex items-center gap-1.5 mb-2">
      <i class="pi pi-history text-red-500 text-sm"></i>
      <h3 class="font-semibold text-sm text-gray-700">Disable / Enable History</h3>
    </div>

    <div class="space-y-2">
      <div v-for="record in history" :key="record.id"
        class="border rounded p-2 text-xs"
        :class="record.is_current ? 'border-red-200 bg-red-50' : 'border-gray-200 bg-gray-50'">
        <div class="flex items-center justify-between mb-1">
          <Tag :value="record.is_current ? 'Currently Disabled' : 'Resolved'" :severity="record.is_current ? 'danger' : 'success'" class="!text-[10px]" />
          <span class="text-[11px] text-gray-500">{{ formatDate(record.disabled_at) }}</span>
        </div>
        <p class="text-gray-700"><strong>Reason:</strong> {{ record.disabled_reason }}</p>
        <p v-if="record.disabledByUser" class="text-gray-500"><strong>Disabled by:</strong> {{ record.disabledByUser.name }}</p>
        <div v-if="record.enabled_at" class="mt-1 pt-1 border-t border-gray-200">
          <p class="text-green-700"><strong>Enabled:</strong> {{ formatDate(record.enabled_at) }}</p>
          <p v-if="record.enabled_reason" class="text-gray-600"><strong>Enable reason:</strong> {{ record.enabled_reason }}</p>
          <p v-if="record.enabledByUser" class="text-gray-500"><strong>Enabled by:</strong> {{ record.enabledByUser.name }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useQuery } from '@vue/apollo-composable';
import { GET_STUDENT_DISABLEMENT_HISTORY } from '@/graphql/mutations/studentOverview';

const props = defineProps<{
  studentId: number | string
}>();

const { result } = useQuery(GET_STUDENT_DISABLEMENT_HISTORY, { student_id: String(props.studentId) }, { fetchPolicy: 'network-only' });

const history = computed(() => result.value?.studentDisablementHistory ?? []);

function formatDate(dateStr: string) {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
</script>
